import NewSlideshow from '../../classes/NewSlideshow';
import {Lightbox} from '../../classes/Lightbox';

export const isImgLoad = ( img ) => {
	return img && img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;
};

const move = ( evt, sliderClass ) => {
	if ( evt.code === 'ArrowRight' )
	{
		sliderClass.next();
	}
	else if ( evt.code === 'ArrowLeft' )
	{
		sliderClass.prev();
	}
};

export const initSlider = ( lightBox, currentImage ) => {
	const sliderWrapper = lightBox.querySelector( 'div.slider' );

	if ( sliderWrapper )
	{
		const sliderInstance = new NewSlideshow( {
			element: sliderWrapper,
			loop: true,
			currentIndex: currentImage,
		} );

		sliderInstance.init();

		document.addEventListener( 'keydown', ( event ) => move( event, sliderInstance ) );
	}

	lightBox.addEventListener( 'click', ( {target} ) => {
		if ( !target.closest( '.slides-wrapper' ) )
		{
			lightBox.querySelector( 'button.close' ).click();
		}
	}, true );
};

export const initGallery = () => {
	const galleryWrappers = document.querySelectorAll( '.gallery' );
	
	if ( !galleryWrappers )
	{
		return;
	}

	galleryWrappers.forEach( ( galleryWrapper ) => {
		const pictures = galleryWrapper.querySelectorAll( '.card img' );
		if ( !pictures )
		{
			return;
		}

		const galleryId = galleryWrapper.getAttribute( 'id' );

		const getSliderContent = async ( url, currentImage ) => {
			await fetch( url, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
				},
				body: `action=get-gallery-lightbox-slider&component-id=${galleryId}&current-slide=${currentImage}`,
			} )
				.then( ( data ) => {
					if ( !data.ok )
					{
						throw new Error( `Could not fetch ${url}, status: ${data.status}` );
					}
	
					return data.json();
				} )
				.then( ( response ) => {
					if ( response && response.rendered )
					{
						Lightbox.open( response.rendered, null, 'slider-lightbox' );
						
						const lightBox = Lightbox.getLightbox();
	
						if ( !lightBox )
						{
							return;
						}
	
						const images = lightBox.querySelectorAll( 'li.slide img' );
						
						for ( let i = 0; i < 1; i++ )
						{
							if ( isImgLoad( images[i] ) )
							{
								initSlider( lightBox, currentImage );
							}
							else
							{
								images[i].onload = () => initSlider( lightBox, currentImage );
							}
						}
					}
				} );
		};

		galleryWrapper.addEventListener( 'click', ( {target} ) => {
			if ( target.closest( 'button.count' ) )
			{
				getSliderContent( '/ajax/', 0 );
				return;
			}
			
			const button = target.closest( 'button' );
			
			if ( button )
			{
				const img = button.querySelector( 'img' );
				
				pictures.forEach( ( pic, i ) => {
					if ( img === pic )
					{
						getSliderContent( '/ajax/', i );
					}
				} );
			}
		} );
	} );
};
